<section>
  <app-welcome-navbar />
  <div
    class="h-screen overflow-hidden bg-[url('/img/bo-bg.webp')] bg-cover bg-center">
    <!-- Text Cards -->
    <div
      class="absolute z-10 grid h-full w-full grid-cols-1 px-5 py-40 sm:px-25 sm:py-30 lg:grid-cols-2 lg:py-0">
      <!-- Column Left -->
      <div
        class="col-span-1 flex flex-col items-center gap-5 lg:items-start lg:justify-around lg:gap-0">
        <div class="flex flex-col gap-5 lg:flex-row lg:gap-0">
          <div
            class="flex h-fit max-w-lg flex-col gap-2 rounded-md border border-white/10 bg-white/10 px-5 py-3 backdrop-blur-md">
            <h2 class="text-xs font-semibold text-white">
              Administra tu plataforma de vehículos desde un solo lugar
            </h2>
            <p class="max-w-sm text-[10px] text-white">
              Administra cada aspecto de tu aplicación de vehículos con una
              plataforma intuitiva y centralizada. Desde el manejo de usuarios
              hasta la configuración de financiamientos, aquí encontrarás todas
              las herramientas que necesitas para operar de forma eficiente.
            </p>
          </div>
          <div
            class="h-fit max-w-lg flex-col gap-2 rounded-md border border-white/10 bg-white/10 px-5 py-3 backdrop-blur-md sm:flex lg:-translate-x-5 lg:translate-y-20">
            <h2 class="text-xs font-semibold text-white">
              El centro de control para tu ecosistema automotriz
            </h2>
            <p class="max-w-sm text-[10px] text-white">
              Simplifica tu trabajo diario con un panel que te permite controlar
              vehículos, planes, clientes y procesos desde un único sitio. Todo
              diseñado para que crezcas sin perder tiempo.
            </p>
          </div>
        </div>
        <div
          class="hidden max-w-lg flex-col gap-2 rounded-md border border-white/10 bg-white/10 px-5 py-3 backdrop-blur-md lg:flex">
          <h2 class="text-xs font-semibold text-white">
            Tu backoffice para una administración rápida y eficiente
          </h2>
          <p class="max-w-sm text-[10px] text-white">
            Nuestro panel centralizado te permite mantener el control total de
            tu operación, optimizar tiempos y asegurar que cada dato esté
            siempre actualizado. Todo en un entorno intuitivo, seguro y
            preparado para acompañar el crecimiento de tu negocio automotriz.
          </p>
        </div>
      </div>
      <!-- Column Right -->
      <div
        class="col-span-1 hidden flex-col justify-around gap-5 lg:flex lg:items-end lg:gap-0">
        <div class="flex flex-col gap-5 lg:flex-row lg:gap-0">
          <div
            class="flex h-fit max-w-lg flex-col gap-2 rounded-md border border-white/10 bg-white/10 px-5 py-3 backdrop-blur-md">
            <h2 class="text-xs font-semibold text-white">
              Gestión inteligente para tu app de vehículos
            </h2>
            <p class="max-w-sm text-[10px] text-white">
              Optimiza la gestión de tu negocio automotriz con una interfaz
              clara, flexible y pensada para administradores. Mantén la
              información ordenada, actualizada y siempre disponible.
            </p>
          </div>
        </div>
        <div>
          <div
            class="flex max-w-lg flex-col gap-2 rounded-md border border-white/10 bg-white/10 px-5 py-3 backdrop-blur-md">
            <h2 class="text-xs font-semibold text-white">
              Control Total de Usuarios
            </h2>
            <p class="max-w-sm text-[10px] text-white">
              Mantén un registro organizado de clientes, administradores y
              colaboradores, revisa su actividad, actualiza información en
              segundos y garantiza que cada usuario tenga el nivel de acceso
              adecuado..
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- Car image -->
    <div
      class="flex h-full items-center justify-center pt-60 lg:items-end lg:pt-0">
      <img src="/img/welcome-car.webp" alt="Haval Jolion" class="w-[1120px]" />
    </div>

    <!-- Hello Tomorrow! Button -->
    <a
      href="https://www.gwm-ve.com/"
      class="absolute bottom-10 left-1/2 z-999 flex -translate-x-1/2 scale-100 transform items-center gap-2 transition-all duration-300 ease-in-out hover:scale-105 sm:bottom-15">
      <h1
        class="flex items-baseline gap-3 border-b border-white pb-1 text-3xl font-bold text-white sm:text-5xl">
        <span>Hello</span>
        <span class="text-outline">Tomorrow!</span>
      </h1>
      <div>
        <img
          src="/img/icons/input_circle.svg"
          alt="Scroll Down"
          class="min-w-13" />
      </div>
    </a>
  </div>
  <!-- Social Media -->
  <div
    class="absolute top-25 z-50 mx-auto flex h-full w-full justify-center gap-15 text-white sm:top-0 sm:right-7 sm:flex-col sm:items-end">
    @for (item of socialMedias(); track $index) {
      <a
        [href]="item.url"
        target="_blank"
        class="scale-100 text-white transition-transform duration-300 ease-in-out sm:hover:scale-110">
        <ng-icon [name]="item.icon" size="20px" />
      </a>
    }
  </div>
</section>
